export const REGION_DASHBOARDS_VES = 'regionDashboardsVES';

export const REGION_DASHBOARDS_VES_ACTIONS_NAME = {
  getBaseRegionInfo: `${REGION_DASHBOARDS_VES}/getBaseRegionInfo`,
  getRatingCards: `${REGION_DASHBOARDS_VES}/getRatingCards`,
  getRatingList: `${REGION_DASHBOARDS_VES}/getRatingList`,
  getIndicatorCards: `${REGION_DASHBOARDS_VES}/getIndicatorCards`,
  getDynamicCards: `${REGION_DASHBOARDS_VES}/getDynamicCards`,
  getEventsCountByTypes: `${REGION_DASHBOARDS_VES}/getEventsCountByTypes`,
  getAgreementsCountByTypes: `${REGION_DASHBOARDS_VES}/getAgreementsCountByTypes`,
  getRepresentativeAbroadInfo: `${REGION_DASHBOARDS_VES}/getRepresentativeAbroadInfo`,
  getRepresentativeAbroadInfoTable: `${REGION_DASHBOARDS_VES}/getRepresentativeAbroadInfoTable`,
};

export const REGION_DASHBOARDS_VES_MUTATIONS_NAME = {
  setBaseRegionInfo: `${REGION_DASHBOARDS_VES}/setBaseRegionInfo`,
  setRatingCards: `${REGION_DASHBOARDS_VES}/setRatingCards`,
  setRatingList: `${REGION_DASHBOARDS_VES}/setRatingList`,
  setIndicatorCards: `${REGION_DASHBOARDS_VES}/setIndicatorCards`,
  setDynamicCards: `${REGION_DASHBOARDS_VES}/setDynamicCards`,
  setEventsCountByTypes: `${REGION_DASHBOARDS_VES}/setEventsCountByTypes`,
  setAgreementsCountByTypes: `${REGION_DASHBOARDS_VES}/setAgreementsCountByTypes`,
  setRepresentativeAbroadInfo: `${REGION_DASHBOARDS_VES}/setRepresentativeAbroadInfo`,
  setRepresentativeAbroadInfoTable: `${REGION_DASHBOARDS_VES}/setRepresentativeAbroadInfoTable`,
};

export const REGION_DASHBOARDS_VES_GETTERS_NAME = {
  getBaseRegionInfo: `${REGION_DASHBOARDS_VES}/getBaseRegionInfo`,
  getRatingCards: `${REGION_DASHBOARDS_VES}/getRatingCards`,
  getRatingList: `${REGION_DASHBOARDS_VES}/getRatingList`,
  getIndicatorCards: `${REGION_DASHBOARDS_VES}/getIndicatorCards`,
  getDynamicCards: `${REGION_DASHBOARDS_VES}/getDynamicCards`,
  getEventsCountByTypes: `${REGION_DASHBOARDS_VES}/getEventsCountByTypes`,
  getAgreementsCountByTypes: `${REGION_DASHBOARDS_VES}/getAgreementsCountByTypes`,
  getRepresentativeAbroadInfo: `${REGION_DASHBOARDS_VES}/getRepresentativeAbroadInfo`,
  getRepresentativeAbroadInfoTable: `${REGION_DASHBOARDS_VES}/getRepresentativeAbroadInfoTable`,
};
